import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { MicroLabel } from './micro-label';

type Tone = 'foreground' | 'primary';
type FootTone = 'muted' | 'pass' | 'warn' | 'danger' | 'primary';

/**
 * The dashboard stat tile: mono caption, one large number, one colored footnote.
 * The footnote is mono too - it is always a derived comparison, never prose.
 */
export function StatTile({
  label,
  value,
  foot,
  footTone = 'muted',
  tone = 'foreground',
  className
}: {
  label: string;
  value: ReactNode;
  foot?: ReactNode;
  footTone?: FootTone;
  tone?: Tone;
  className?: string;
}) {
  return (
    <article className={cn('rounded border border-border bg-card px-5 py-4', className)}>
      <MicroLabel size="xs">{label}</MicroLabel>
      <strong
        className={cn(
          'mt-3 block text-[34px] leading-none font-medium tracking-tight',
          tone === 'primary' ? 'text-primary' : 'text-foreground'
        )}
      >
        {value}
      </strong>
      {foot ? (
        <MicroLabel size="xs" tone={footTone} caps={false} className="mt-3 block">
          {foot}
        </MicroLabel>
      ) : (
        <span className="mt-3 block h-[11px]" />
      )}
    </article>
  );
}
